module.exports = __webpack_public_path__ + "static/media/nssc_icon.7d1697a6.png";